import React from "react";
import {Tag} from "antd";

const getStatusDetails = (status) => {
  switch (status) {
  case 0:
    return {label: "Pending Insert", color: "orange"};
  case 1:
    return {label: "Active", color: "green"};
  case 2:
    return {label: "Pending Update", color: "blue"};
  case 3:
    return {label: "Pending Delete", color: "red"};
  default:
    return {label: "Unknown", color: "gray"};
  }
};

const StatusTag = ({status}) => {
  const {label, color} = getStatusDetails(status);

  return (
    <Tag color={color}>
      {label}
    </Tag>
  );
};

export default StatusTag;
